export default {"src":"/_next/static/media/out_filled.bf59c63d.svg","height":24,"width":24};